import * as types from '../actions/types';
import { UPDATE_TICKET } from '../actions/types';
import { isTicketBeingViewed } from '../extractFromState';
import { isLiveChat } from 'util/chat';
import moment from 'moment';
import { createNotification } from '../actions/notificationActions';
import { ASSIGNED } from '../constants/tabNames';

const initialState = {
  tabNotificationsQueue: [], // notification: { ticketId, title, body }
  currentTabNotificationAppearedAt: null,
};

const clearTicketFromNotifications = (state, ticketId) => {
  const tabNotificationsQueue = state.tabNotificationsQueue.filter(
    (notification) => notification.ticketId !== ticketId
  );

  if (state.tabNotificationsQueue.length > 0 && state.tabNotificationsQueue[0].ticketId === ticketId) {
    return {
      ...state,
      currentTabNotificationAppearedAt: new Date().toISOString(),
      tabNotificationsQueue,
    };
  }

  return {
    ...state,
    tabNotificationsQueue,
  };
};

// also updates currentTabNotificationAppearedAt if needed
const addTabNotificationToQueue = (state, notification) => {
  if (state.tabNotificationsQueue.length > 0) {
    return {
      ...state,
      tabNotificationsQueue: [...state.tabNotificationsQueue, notification],
    };
  }

  return {
    ...state,
    currentTabNotificationAppearedAt: new Date().toISOString(),
    tabNotificationsQueue: [...state.tabNotificationsQueue, notification],
  };
};

// if first ticket is old, and there are more in the queue, remove it
const rotateNotificationsIfMultiple = (state) => {
  if (
    state.tabNotificationsQueue.length > 1 &&
    state.currentTabNotificationAppearedAt !== null &&
    moment(state.currentTabNotificationAppearedAt).add(10000, 'ms').isBefore(moment())
  ) {
    // remove current notification and updates currentTabNotificationAppearedAt
    return {
      ...state,
      currentTabNotificationAppearedAt: new Date().toISOString(),
      tabNotificationsQueue: state.tabNotificationsQueue.slice(1),
    };
  }

  return state;
};

const addNotification = (state, notification) => {
  return {
    ...state,
    tabNotificationsQueue: [...state.tabNotificationsQueue, notification],
  };
};

export const notifications = (state = initialState, action, globalState) => {
  switch (action.type) {
    case types.ADD_TAB_NOTIFICATION_TO_QUEUE:
      return rotateNotificationsIfMultiple(addTabNotificationToQueue(state, action.notification));

    case types.CLEAR_TAB_NOTIFICATIONS_FOR_TICKET:
    case types.REMOVE_TICKET:
      return clearTicketFromNotifications(state, action.ticketId);
    case types.MOVE_TICKET:
      return clearTicketFromNotifications(state, action.conversationObjectId);

    case types.ROTATE_NOTIFICATIONS_IF_MULTIPLE:
      return rotateNotificationsIfMultiple(state);

    case types.SELECT_ASSIGNED_TICKET:
    case types.SELECT_LIVE_CHAT_TICKET:
      return clearTicketFromNotifications(state, action.selectedTicketId);

    case UPDATE_TICKET:
      if (action.queueName === ASSIGNED) {
        const currentTicket = globalState.tickets.assignedTickets[action.ticket.ticketId];
        if (!currentTicket) {
          return state;
        }

        const hasNewMessage = action.ticket.unreadCount > currentTicket.unreadCount;
        if (
          isLiveChat(currentTicket.communicationType) &&
          hasNewMessage &&
          !isTicketBeingViewed(globalState, action.ticket.ticketId)
        ) {
          return rotateNotificationsIfMultiple(addTabNotificationToQueue(state, createNotification(action.ticket)));
        }

        return state;
      }

      return state;

    case types.CLEAR_ALL_TAB_NOTIFICATIONS:
      return initialState;
    case types.ADD_NOTIFICATION:
      return addNotification(state, action.notification);
    case types.REMOVE_NOTIFICATION:
      return clearTicketFromNotifications(state, action.ticketId);
    default:
      return state;
  }
};

export default notifications;
